import React from 'react'
import rg4js from 'raygun4js'
import { connect } from 'react-redux'
import StartErrorPage from './Start/StartErrorPage'
import StartPageStyle from '../styles/StartPageStyle'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
    if (!this.isLocalhost()) {
      rg4js('enableCrashReporting', true)
      rg4js('apiKey', 'yXxQMDiLoWMZ3emPHy19MA==')
      rg4js('withTags', ['CLIENT'])
    }
  }

  isLocalhost() {
    return (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '[::1]' ||
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
      )
    )
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true })
    rg4js('setUser', {
      identifier: this.props.licencja ? this.props.licencja.numer : 'brak',
      email: null,
      isAnonymous: false,
      firstName: this.props.licencja ? this.props.licencja.system : 'brak',
      fullName: this.props.licencja ? this.props.licencja.nazwaFirmy : 'brak',
    })
    rg4js('send', error)
  }

  render() {
    if (this.state.hasError) {
      return (
        <StartPageStyle licencja={this.props.licencja}>
          <StartErrorPage />
        </StartPageStyle>
      )
    }
    return this.props.children
  }
}

const mapStateToProps = state => {
  return {
    licencja: state.sprawozdanie.licencja,
  }
}

export default connect(
  mapStateToProps,
  null,
)(ErrorBoundary)
